{
  "common": {
    "ok": "OK",
    "cancel": "Annuler",
    "yes": "Oui",
    "no": "Non",
    "loading": "Chargement...",
    "error": "Erreur",
    "retry": "Réessayer",
    "apply": "Appliquer",
    "add": "Ajouter"
  },
  "navigation": {
    "home": "Accueil",
    "favorites": "Favoris",
    "search": "Rechercher"
  },
  "jobs": {
    "noJobs": "Aucun emploi trouvé",
    "loadMore": "Charger plus",
    "apply": "Postuler",
    "save": "Sauvegarder",
    "unsave": "Retirer"
  },
  "search": {
    "placeholder": "Rechercher des emplois...",
    "filter": "Filtrer",
    "clear": "Effacer",
    "open": "Rechercher des emplois",
    "close": "Fermer la recherche"
  },
  "alerts": {
    "title": "Alertes d'emploi",
    "subtitle": "Recevez une notification quand de nouvelles offres correspondent à votre recherche.",
    "placeholder": "Mots-clés (ex. react remote senior)",
    "empty": "Aucune alerte",
    "matchingNow": "{{count}} correspondent"
  },
  "description": {
    "openUrlMessage": "Ouvrir l'URL pour plus d'informations",
    "postedOn": "Publié le",
    "applyViewDetails": "Postuler / Voir les détails"
  },
  "error": {
    "title": "Quelque chose s'est mal passé",
    "description": "Désolé, aucun emploi trouvé ! C'est probablement une erreur de serveur ou de réseau.",
    "tryAgain": "Réessayer"
  },
  "filter": {
    "refineJobs": "Affiner les emplois",
    "title": "Filtrer",
    "total": "au total",
    "reset": "Réinitialiser",
    "filterByDate": "Filtrer par date",
    "byDate": "Par date",
    "byApplied": "Par candidatures",
    "appliedOnlyOn": "Candidatures seules : activé",
    "appliedOnlyOff": "Candidatures seules : désactivé",
    "postedAfter": "Publié après le",
    "filterByTags": "Filtrer par tags",
    "byTag": "Par tag",
    "clearAllFavorites": "Effacer tous les favoris",
    "applyFilters": "Appliquer les filtres"
  },
  "share": {
    "message": "Voici une excellente opportunité d'emploi à distance :\n* Poste : {{position}}\n* Entreprise : {{company}}\n* URL : {{url}}",
    "title": "App Travail à Distance - {{position}} @{{company}}",
    "subject": "Emploi partagé depuis App Travail à Distance",
    "dialogTitle": "Partager un emploi à distance"
  },
  "datepicker": {
    "selectDate": "Sélectionner la date",
    "year": "Année",
    "month": "Mois",
    "previousMonth": "Mois précédent",
    "nextMonth": "Mois suivant",
    "weekdays": [
      "Dim",
      "Lun",
      "Mar",
      "Mer",
      "Jeu",
      "Ven",
      "Sam"
    ],
    "months": [
      "Janvier",
      "Février",
      "Mars",
      "Avril",
      "Mai",
      "Juin",
      "Juillet",
      "Août",
      "Septembre",
      "Octobre",
      "Novembre",
      "Décembre"
    ]
  },
  "tabs": {
    "allJobs": "Tous les emplois",
    "favorites": "Favoris",
    "resumeBuilder": "CV",
    "applications": "Candidatures",
    "profile": "Profil"
  },
  "favorites": {
    "deleteAll": "Supprimer tous les favoris",
    "empty": "Aucun favori pour le moment. Touchez le cœur d'une offre pour l'enregistrer ici."
  },
  "icons": {
    "jobActions": "Actions sur le poste",
    "addToFavorites": "Ajouter aux favoris",
    "removeFromFavorites": "Retirer des favoris",
    "share": "Partager",
    "openUrl": "Ouvrir l'URL",
    "markApplied": "Marquer comme postulé",
    "removeApplied": "Retirer postulé"
  },
  "job": {
    "applied": "Postulé",
    "fit": "Affinité {{score}}%"
  },
  "list": {
    "found": "trouvés"
  },
  "onboarding": {
    "tagline": "Découvrez des opportunités à distance sélectionnées du monde entier !",
    "next": "Suivant"
  },
  "tour": {
    "skip": "Passer",
    "next": "Suivant",
    "getStarted": "Commencer",
    "slides": {
      "welcome": {
        "title": "Bienvenue",
        "description": "Un tour rapide des fonctionnalités principales pour trouver votre prochain emploi à distance plus vite."
      },
      "search": {
        "title": "Rechercher et filtrer",
        "description": "Recherchez par mot-clé et affinez les résultats par date, étiquettes ou statut de candidature."
      },
      "favorites": {
        "title": "Favoris et candidatures",
        "description": "Appuyez sur le cœur pour enregistrer une offre et marquez celles auxquelles vous avez postulé."
      },
      "tracker": {
        "title": "Suivez vos candidatures",
        "description": "Marquez les offres comme postulées et suivez chacune par étapes — entretien, offre — avec notes et dates."
      },
      "alerts": {
        "title": "Recevez des alertes pour les nouvelles offres",
        "description": "Enregistrez une recherche et recevez une notification dès que de nouvelles offres à distance correspondent à vos mots-clés."
      },
      "resume": {
        "title": "Créez votre CV",
        "description": "Créez un CV professionnel, exportez-le en PDF ou DOCX et voyez à quel point chaque offre correspond à vos compétences."
      },
      "account": {
        "title": "Connectez-vous pour synchroniser",
        "description": "Créez un compte gratuit pour sauvegarder vos CV, candidatures, favoris et alertes sur tous vos appareils."
      },
      "settings": {
        "title": "Thèmes et langues",
        "description": "Basculez entre clair et sombre et choisissez parmi 9 langues dans les paramètres."
      }
    }
  },
  "theme": {
    "toggle": "Changer de thème"
  },
  "settings": {
    "title": "Paramètres",
    "theme": "Thème",
    "themeLight": "Clair",
    "themeDark": "Sombre",
    "language": "Langue",
    "open": "Ouvrir les paramètres",
    "close": "Fermer",
    "developer": "Développeur",
    "hideAds": "Masquer les publicités",
    "removeAds": {
      "title": "Supprimer les publicités",
      "buy": "Supprimer les publicités — {{price}}",
      "restore": "Restaurer les achats",
      "purchased": "Merci de soutenir RemoteWork ! Les publicités sont désactivées.",
      "successTitle": "Publicités supprimées",
      "successMessage": "Merci pour votre soutien ! Les publicités sont maintenant désactivées dans toute l'application.",
      "errorTitle": "Échec de l'achat",
      "errorMessage": "Une erreur est survenue. Veuillez réessayer.",
      "restoreEmptyTitle": "Rien à restaurer",
      "restoreEmptyMessage": "Aucun achat précédent n'a été trouvé sur ce compte."
    },
    "tour": "Tour",
    "replayTour": "Revoir le tour",
    "account": "Compte",
    "deleteAccount": {
      "action": "Supprimer le compte",
      "confirmTitle": "Supprimer le compte ?",
      "confirmMessage": "Cela supprime définitivement votre compte et toutes les données synchronisées — CV, candidatures, favoris et alertes. Action irréversible.",
      "errorTitle": "Impossible de supprimer le compte",
      "errorMessage": "Une erreur est survenue. Veuillez réessayer.",
      "reauthMessage": "Pour votre sécurité, déconnectez-vous puis reconnectez-vous, et réessayez de supprimer votre compte."
    },
    "about": "À propos",
    "privacyPolicy": "Politique de confidentialité",
    "website": "Visiter le site web"
  },
  "ad": {
    "sponsored": "Sponsorisé"
  },
  "consent": {
    "message": "Nous utilisons des cookies d'analyse pour comprendre comment le site est utilisé. Ils restent désactivés tant que vous n'avez pas accepté.",
    "accept": "Accepter",
    "reject": "Refuser"
  },
  "disclaimer": {
    "title": "À propos des offres d'emploi",
    "message": "Les offres affichées dans cette application proviennent de sources tierces et d'API publiques. Nous ne publions, ne sélectionnons ni ne contrôlons ces annonces, et nous ne pouvons pas garantir l'exactitude, la qualité ou la disponibilité d'un poste. Vérifiez toujours les détails directement auprès de l'employeur avant de postuler.",
    "okCountdown": "OK ({{seconds}})"
  },
  "resume": {
    "title": "Créateur de CV",
    "newResume": "Nouveau",
    "newResumePrompt": "Nommez votre CV",
    "namePlaceholder": "Ex. : CV Frontend",
    "lastModified": "Dernière modification",
    "discardTitle": "Abandonner les modifications ?",
    "discardMessage": "Vous avez des modifications non enregistrées.",
    "webPlaceholder": {
      "title": "Le créateur de CV est réservé au mobile",
      "subtitle": "Ouvrez l'application sur Android ou iOS pour créer et exporter votre CV."
    },
    "actions": {
      "edit": "Modifier",
      "duplicate": "Dupliquer",
      "delete": "Supprimer",
      "more": "Plus d'options",
      "deleteConfirmTitle": "Supprimer le CV ?",
      "deleteConfirmMessage": "Supprimer définitivement \"{{name}}\" ? Cette action est irréversible."
    },
    "empty": {
      "title": "Aucun CV pour le moment",
      "subtitle": "Créez un CV professionnel et exportez-le en PDF ou DOCX.",
      "cta": "Créer mon premier CV",
      "skillsHint": "Ajoutez des compétences comme JavaScript, design, leadership…"
    },
    "sections": {
      "personalInfo": "Informations personnelles",
      "experience": "Expérience",
      "education": "Formation",
      "skills": "Compétences",
      "languages": "Langues",
      "links": "Liens",
      "template": "Modèle",
      "contact": "Contact",
      "summary": "Résumé",
      "personalization": "Personnalisation",
      "preview": "Aperçu"
    },
    "fields": {
      "fullName": "Nom complet",
      "title": "Titre professionnel",
      "email": "E-mail",
      "phone": "Téléphone",
      "location": "Localisation",
      "website": "Site web",
      "summary": "Résumé professionnel",
      "company": "Entreprise",
      "position": "Poste",
      "institution": "Établissement",
      "degree": "Diplôme",
      "field": "Domaine d'études",
      "startDate": "Début",
      "endDate": "Fin",
      "current": "J'y travaille actuellement",
      "present": "Aujourd'hui",
      "description": "Description",
      "skillPlaceholder": "Ajouter une compétence",
      "languageName": "Langue",
      "languageProficiency": "Niveau",
      "linkLabel": "Libellé",
      "linkUrl": "URL",
      "phoneCountryCode": "Indicatif"
    },
    "proficiency": {
      "basic": "Notions",
      "conversational": "Conversationnel",
      "fluent": "Courant",
      "native": "Langue maternelle"
    },
    "templates": {
      "modern": "Moderne",
      "classic": "Classique",
      "minimal": "Minimaliste",
      "modernDescription": "Mise en page sur deux colonnes avec une barre latérale colorée.",
      "classicDescription": "Traditionnel, en noir et blanc, sur une seule colonne.",
      "minimalDescription": "Épuré, beaucoup d'espace blanc, sans couleur."
    },
    "buttons": {
      "addExperience": "Ajouter une expérience",
      "addEducation": "Ajouter une formation",
      "addLanguage": "Ajouter une langue",
      "addLink": "Ajouter un lien",
      "remove": "Retirer",
      "save": "Enregistrer",
      "discard": "Abandonner",
      "export": "Exporter",
      "exportPdf": "Exporter en PDF",
      "exportDocx": "Exporter en DOCX",
      "create": "Créer",
      "previous": "Précédent",
      "next": "Suivant"
    },
    "export": {
      "preparing": "Préparation du fichier…",
      "preparingHint": "Choisissez un format. Le fichier s'ouvrira dans le menu de partage.",
      "errorTitle": "Échec de l'export",
      "errorMessage": "Une erreur s'est produite lors de l'export de votre CV."
    },
    "validation": {
      "invalidEmail": "Veuillez saisir une adresse e-mail valide.",
      "invalidCountryCode": "Jusqu'à 4 chiffres, éventuellement précédés de +.",
      "invalidWebsite": "Saisissez un site web valide (ex. exemple.com)."
    },
    "personalization": {
      "title": "Personnaliser",
      "colorMode": "Thème de couleur",
      "modes": {
        "light": "Clair",
        "dark": "Sombre"
      },
      "fontFamily": "Police",
      "fonts": {
        "sans": "Sans",
        "serif": "Serif",
        "modern": "Moderne",
        "mono": "Mono"
      },
      "fontSize": "Taille de la police",
      "sizes": {
        "title": "Titre",
        "subtitle": "Sous-titre",
        "body": "Corps"
      },
      "increase": "Augmenter {{field}}",
      "decrease": "Réduire {{field}}"
    },
    "photo": {
      "placeholder": "Aucune photo",
      "choose": "Ajouter une photo",
      "change": "Changer la photo",
      "remove": "Retirer",
      "permissionTitle": "Autorisation requise",
      "permissionMessage": "Autorisez l’accès à la galerie pour choisir une photo de profil."
    }
  },
  "sort": {
    "recent": "Plus récents",
    "bestFit": "Meilleure affinité",
    "toggle": "Trier par affinité"
  },
  "applyKit": {
    "title": "Kit de candidature",
    "hint": "Touchez pour copier et coller dans le formulaire.",
    "copied": "Copié",
    "openExternal": "Ouvrir dans le navigateur"
  },
  "applications": {
    "title": "Candidatures",
    "empty": {
      "title": "Aucune candidature",
      "subtitle": "Les offres auxquelles vous postulez apparaissent ici pour suivre leur statut."
    },
    "status": {
      "applied": "Postulé",
      "interviewing": "Entretien",
      "offer": "Offre",
      "rejected": "Refusé"
    },
    "notesPlaceholder": "Ajouter des notes…",
    "remove": "Retirer",
    "removeConfirm": "Retirer cette candidature ?",
    "lastUpdate": "Dernière mise à jour : {{date}}",
    "editDate": "Modifier la date",
    "addManual": "Ajouter une candidature"
  },
  "auth": {
    "account": "Compte",
    "signIn": "Se connecter",
    "signUp": "Créer un compte",
    "signOut": "Se déconnecter",
    "title": {
      "signIn": "Bon retour",
      "signUp": "Créez votre compte"
    },
    "email": "E-mail",
    "password": "Mot de passe",
    "showPassword": "Afficher le mot de passe",
    "hidePassword": "Masquer le mot de passe",
    "forgotPassword": "Mot de passe oublié ?",
    "resetSent": "E-mail de réinitialisation envoyé — vérifiez votre boîte.",
    "enterEmailFirst": "Saisissez d'abord votre e-mail.",
    "noAccount": "Pas de compte ? Créez-en un",
    "haveAccount": "Déjà un compte ? Connectez-vous",
    "criteria": {
      "minLength": "Au moins 8 caractères",
      "uppercase": "Une lettre majuscule",
      "lowercase": "Une lettre minuscule",
      "numeric": "Un chiffre",
      "special": "Un caractère spécial"
    },
    "errors": {
      "invalid-email": "Cet e-mail semble invalide.",
      "invalid-credential": "E-mail ou mot de passe incorrect.",
      "user-not-found": "Aucun compte trouvé avec cet e-mail.",
      "wrong-password": "E-mail ou mot de passe incorrect.",
      "email-already-in-use": "Un compte existe déjà avec cet e-mail.",
      "weak-password": "Ce mot de passe ne respecte pas les exigences.",
      "requires-recent-login": "Veuillez vous reconnecter pour continuer.",
      "too-many-requests": "Trop de tentatives. Réessayez plus tard.",
      "network": "Erreur réseau. Vérifiez votre connexion.",
      "not-configured": "La connexion n'est pas disponible pour le moment.",
      "unknown": "Une erreur s'est produite. Réessayez."
    },
    "continueGoogle": "Continuer avec Google",
    "continueApple": "Continuer avec Apple",
    "or": "ou",
    "loggedInAnonymous": "Connecté en anonyme",
    "continueAnonymous": "Continuer en anonyme",
    "loggedOutWarning": "Vous n'êtes pas connecté — vos données ne sont que sur cet appareil et pourraient être perdues."
  },
  "profile": {
    "title": "Profil",
    "signInRegister": "Se connecter / S'inscrire",
    "more": "Plus"
  },
  "applyBrowser": {
    "title": "Postuler"
  }
}
